import axios from 'axios';
import  { serviceUrl } from '../../App';

export default class KanbanDesignService {
   
    
  public getKanbanDesign() {
    return axios.get(
      process.env.REACT_APP_API_GLOBAL_URL+`kanban/kanban-design`
    );
  }
  public addKanbanDesign(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      process.env.REACT_APP_API_GLOBAL_URL+`kanban/kanban-design/create`,
      obj,
      { headers }
    );
  }
  public editKanbanDesign(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      process.env.REACT_APP_API_GLOBAL_URL+`kanban/kanban-design/edit`,
      obj,
      { headers }
    );
  }
  public deleteKanbanDesign(obj: Object) {
    const headers = {
      'Content-Type': 'application/json',
    };
    return axios.put(
      process.env.REACT_APP_API_GLOBAL_URL+`kanban/kanban-design/delete`,
      obj,
      { headers }
    );
  }
}
